(function () {
  'use strict';

  function initScrollPathSection(section) {
    if (section.dataset.cspInit) return;
    section.dataset.cspInit = 'true';

    var cfg = {
      pathColor: section.dataset.pathColor || '#343c48',
      pathAnimColor: section.dataset.pathAnimatedColor || '#ffffff',
      dotColor: section.dataset.dotColor || '#ffffff',
      dotStroke: section.dataset.dotStroke || '#0c1016',
      pathWidth: parseFloat(section.dataset.pathWidth) || 3,
      dotRadius: parseFloat(section.dataset.dotRadius) || 5,
      dotStrokeWidth: parseFloat(section.dataset.dotStrokeWidth) || 4,
      dotPadding: parseFloat(section.dataset.dotPadding) || 30,
    };

    /* ── Create SVG canvas ───────────────────────────────────────────────── */
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.classList.add('csp-svg');
    svg.setAttribute('width', '100%');
    svg.setAttribute('aria-hidden', 'true');
    section.insertAdjacentElement('afterbegin', svg);

    var animatedPath = null;
    var scrollHandler = null;
    var rebuildFrame = null;
    var rebuildTimer = null;
    var resizeObserver = null;

    /* ── Coordinate helper ───────────────────────────────────────────────── */
    function coords(target) {
      var tr = target.getBoundingClientRect();
      var sr = section.getBoundingClientRect();
      var rawX = tr.left - sr.left - cfg.dotPadding;
      // On mobile the content is full-width so rawX can go negative (off-canvas).
      // Clamp to ensure the dot + stroke are always inside the SVG.
      var minX = cfg.dotRadius + cfg.dotStrokeWidth + 2;
      return {
        x: Math.max(minX, rawX),
        y: tr.top - sr.top + tr.height / 2,
      };
    }

    /* ── Build path ──────────────────────────────────────────────────────── */
    function buildPath() {
      var targets = Array.from(section.querySelectorAll('.csp-target'));
      if (!targets.length) return;

      svg.setAttribute('height', section.scrollHeight);

      var d = '';
      var prevX = 0;
      var prevY = 0;
      var round = 120;
      var sectionBottom = section.scrollHeight;

      targets.forEach(function (target, i) {
        var c = coords(target);

        if (i === 0) {
          d += 'M ' + c.x + ' 0';
          d += ' L ' + c.x + ' ' + c.y;
        } else if (Math.abs(c.x - prevX) > 20) {
          var midY = (c.y + prevY) / 2;
          if (c.x < prevX) {
            d += ' L ' + prevX + ' ' + (midY - round);
            d += ' Q ' + prevX + ' ' + midY + ', ' + (prevX - round) + ' ' + midY;
            d += ' L ' + (c.x + 100) + ' ' + midY;
            d += ' Q ' + c.x + ' ' + midY + ', ' + c.x + ' ' + (midY + round);
          } else {
            d += ' L ' + prevX + ' ' + (midY - round);
            d += ' Q ' + prevX + ' ' + midY + ', ' + (prevX + round) + ' ' + midY;
            d += ' L ' + (c.x - 100) + ' ' + midY;
            d += ' Q ' + c.x + ' ' + midY + ', ' + c.x + ' ' + (midY + round);
          }
        } else {
          d += ' L ' + c.x + ' ' + c.y;
        }

        prevX = c.x;
        prevY = c.y;
      });

      d += ' L ' + prevX + ' ' + sectionBottom;

      /* Background dotted guide path */
      var bgPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      bgPath.setAttribute('d', d);
      bgPath.setAttribute('fill', 'none');
      bgPath.setAttribute('stroke', cfg.pathColor);
      bgPath.setAttribute('stroke-width', cfg.pathWidth);
      bgPath.setAttribute('stroke-dasharray', '1,10');
      bgPath.setAttribute('stroke-linejoin', 'round');
      bgPath.setAttribute('stroke-linecap', 'round');
      svg.appendChild(bgPath);

      /* Animated foreground path */
      animatedPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      animatedPath.setAttribute('d', d);
      animatedPath.setAttribute('fill', 'none');
      animatedPath.setAttribute('stroke', cfg.pathAnimColor);
      animatedPath.setAttribute('stroke-width', cfg.pathWidth);
      animatedPath.setAttribute('stroke-linejoin', 'round');
      animatedPath.setAttribute('stroke-linecap', 'round');
      var totalLength = animatedPath.getTotalLength();
      animatedPath.style.strokeDasharray = totalLength;
      animatedPath.style.strokeDashoffset = totalLength;
      svg.appendChild(animatedPath);

      /* Dot circles at each waypoint */
      targets.forEach(function (target) {
        var c = coords(target);
        var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circle.setAttribute('cx', c.x);
        circle.setAttribute('cy', c.y);
        circle.setAttribute('r', cfg.dotRadius);
        circle.setAttribute('fill', cfg.dotColor);
        circle.setAttribute('stroke', cfg.dotStroke);
        circle.setAttribute('stroke-width', cfg.dotStrokeWidth);
        svg.appendChild(circle);
      });

      tick();
    }

    /* ── Scroll animation ────────────────────────────────────────────────── */
    // Lead offset: path travels ahead of the viewport so each dot is reached
    // just before it scrolls into the upper third of the screen.
    function tick() {
      if (!animatedPath) return;
      var sr = section.getBoundingClientRect();
      var lead = window.innerHeight * 0.4;
      var isMobile = window.innerWidth <= 900;
      var pct = (-sr.top + lead) / sr.height;
      if (isMobile) pct *= 1.1;
      pct = Math.max(0, Math.min(1, pct));
      var len = animatedPath.getTotalLength();
      animatedPath.style.strokeDashoffset = len * (1 - pct);
    }

    /* ── Rebuild (resize / re-init) ──────────────────────────────────────── */
    function rebuild() {
      svg.innerHTML = '';
      animatedPath = null;
      buildPath();
    }

    function scheduleRebuild() {
      if (rebuildFrame) cancelAnimationFrame(rebuildFrame);
      if (rebuildTimer) clearTimeout(rebuildTimer);

      rebuildFrame = requestAnimationFrame(function () {
        rebuildFrame = requestAnimationFrame(function () {
          rebuildFrame = null;
          rebuild();
        });
      });

      rebuildTimer = setTimeout(function () {
        rebuildTimer = null;
        rebuild();
      }, 180);
    }

    /* ── Init: wait for fonts + two rAF for layout settle ────────────────── */
    var fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();
    fontsReady.then(function () {
      scheduleRebuild();
    });

    /* ── Listeners ───────────────────────────────────────────────────────── */
    scrollHandler = tick;
    window.addEventListener('scroll', scrollHandler, { passive: true });
    window.addEventListener('resize', scheduleRebuild);

    var inner = section.querySelector('.csp-inner');
    if ('ResizeObserver' in window && inner) {
      resizeObserver = new ResizeObserver(scheduleRebuild);
      resizeObserver.observe(inner);
    }
  }

  /* ── Bootstrap all instances ─────────────────────────────────────────── */
  function initAll() {
    document.querySelectorAll('.csp-section:not([data-csp-init])').forEach(initScrollPathSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor: re-init on section load / reorder */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.csp-section');
    if (!s) return;
    delete s.dataset.cspInit;
    initScrollPathSection(s);
  });

  document.addEventListener('shopify:section:reorder', initAll);
})();
